import React from 'react';

import { StyledIconButton } from './IconButton.styles';
import { TIconButtonProps } from './IconButton.types';

const IconButton = ({ type = 'button', children, ...props }: TIconButtonProps) => (
  <StyledIconButton type={type} {...props}>
    {children}
  </StyledIconButton>
);

export default IconButton;
